import React, { useEffect, useState, useMemo } from "react"
import { useHistory } from "react-router"
import Button from "../../../../components/Button"
import Table from "../../../../components/Table"
import { getAllPaytmMerchants } from "core/services/api"
import { PAYTM_MERCHANT_COLUMNS } from "./PaytmMerchantColumn"


export default function ManagePaytmMerchants() {
  const history = useHistory()
  const [allPaytmMerchants, setAllPaytmMerchants] = useState([])

  useEffect(() => {
    getAllPaytmMerchants()
      .then((res) => {
        setAllPaytmMerchants(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }, [])

  const onAddPaytmMerchant = (id: any = null) => {
    if (id) {
      history.push(`/managePaytmMerchants/${id}`)
    } else {
      history.push(`/managePaytmMerchants/add`)
    }
  }

  const columns = useMemo(() => {
    const cols = [...PAYTM_MERCHANT_COLUMNS];

    if (!cols.some((col) => col.accessor === "Terminal")) {
      cols.push({
        Header: "",
        accessor: "terminal",
        Cell: (props: any) => (
          <div>
            <Button
              text="Manage Terminal"
              outline={true}
              onClick={() => { }}
              id="terminal-button"
            />
          </div>
        ),
      });
    }

    return cols;
  }, []);


  return (
    <div className="automatic-id-generation-wrapper">
      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>
        <div className="header-text">Paytm Merchants</div>
      </div>

      <div className="manage-centers-container">
        <div className="d-flex justify-content-end">
          <Button text="Add Paytm Merchant"
            onClick={() => onAddPaytmMerchant(null)} id="add-paytm-merchant" />
        </div>
        <div>
          <Table
            data={allPaytmMerchants}
            columns={columns}
            globalFilterRequired={true}
            onRowClick={(id: any) => { }}
            onColClick={(colValue: any, id: any) => {
              if (colValue?.toLowerCase() === "terminal") {
                history.push(`/managePaytmMerchants/${id}/terminal`);
              } else {
                onAddPaytmMerchant(id)
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}
